// Expone jQuery en window. Vive en su propio modulo a proposito.
//
// En ESM los `import` se hoistean: se evaluan TODOS antes de la primera sentencia
// del cuerpo del modulo. Si la asignacion `window.jQuery = ...` estuviera en
// vendor.ts junto a los `import 'admin-lte'`, los plugins se evaluarian antes de
// que window.jQuery existiera. Al estar aca, vendor.ts lo importa primero y la
// asignacion ya ocurrio cuando se evaluan los imports siguientes.

import jquery from 'jquery';

declare global {
    interface Window {
        jQuery: JQueryStatic;
        $: JQueryStatic;
    }
}

window.jQuery = jquery;
window.$ = jquery;

export default jquery;
